import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';
import {Observable} from "rxjs/Observable";

@Injectable()
export class _ReferenceDataService{

  constructor(private http: HttpClient){ }

  getReferenceData(){
    return Observable.forkJoin(this.getAccounts(), this.getAccountGroups(), this.getLiquidityProviders());
  }

  getAccounts(){
    return this.http.get(`${API_URL}/accounts`);
  }

  getAccountGroups(){
    return this.http.get(`${API_URL}/account-groups`);
  }

  getLiquidityProviders(){
    return this.http.get(`${API_URL}/liquidity-providers`);
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/referenceData.service.ts